let isTablet = window.innerWidth < 992, isMobile = window.innerWidth < 576, isAppleDevice = /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);
window.addEventListener("resize", () => {
    isTablet = window.innerWidth < 992;
    isMobile = window.innerWidth < 576;
});
export { isMobile, isTablet, isAppleDevice };
